'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _getSize = require('../../../helpers/getSize');

var _getSize2 = _interopRequireDefault(_getSize);

var _sizes = require('../../../constants/sizes');

var _colors = require('../../../constants/colors');

var _layout = require('../layout');

var _layout2 = _interopRequireDefault(_layout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DefaultIcon = function DefaultIcon(props) {
    return _react2.default.createElement(
        'svg',
        props,
        _react2.default.createElement(
            'defs',
            null,
            _react2.default.createElement('path', {
                id: 'a',
                d: 'M0 52h60V0H0z'
            })
        ),
        _react2.default.createElement(
            'g',
            {
                fill: 'none',
                fillRule: 'evenodd'
            },
            _react2.default.createElement(
                'mask',
                {
                    id: 'b',
                    fill: '#fff'
                },
                _react2.default.createElement('use', {
                    xlinkHref: '#a'
                })
            ),
            _react2.default.createElement('path', {
                d: 'M11 21.375v-12.5l-2-3 1-2.125 2.125-.875 3.625 3 .875 3v10.25h9.5l-1.25-4.75V0l9.5 6.75h8.25l8.5-6.75v18L49 21.375 46.875 24v26h-4.25l-2.375-3.25V39l-2.375-1h-3.5l-1 2v10H23.75l-2.125-2.125V40H15.75v10H11l-2-3.25V30l1-5 1-1v-2.625z',
                fill: '#F7F7F8',
                mask: 'url(#b)'
            }),
            _react2.default.createElement('path', {
                d: 'M38.464 29.31v-1.892c6.705 0 12.161-5.501 12.161-12.264V2.116l-7.913 6.602h-8.496l-7.913-6.602v13.038c0 2.042.507 4.063 1.468 5.845l-1.648.903a14.268 14.268 0 0 1-1.695-6.748V0h2.28l8.183 6.827h7.146L50.219 0H52.5v15.154c0 7.805-6.296 14.155-14.036 14.155',
                fill: '#3F5060',
                mask: 'url(#b)'
            }),
            _react2.default.createElement('path', {
                d: 'M47.839 52h-3.75c-2.585 0-4.687-2.12-4.687-4.727v-6.618a.942.942 0 0 0-.938-.946h-2.812a.942.942 0 0 0-.938.946V52h-3.689c-2.584 0-4.688-2.12-4.688-4.727V35.927h1.875v11.346c0 1.564 1.262 2.836 2.813 2.836h1.814v-9.454c0-1.564 1.262-2.837 2.813-2.837h2.812c1.55 0 2.813 1.273 2.813 2.837v6.618c0 1.564 1.261 2.836 2.812 2.836h1.875V25.017h1.875V52z',
                fill: '#3F5060',
                mask: 'url(#b)'
            }),
            _react2.default.createElement('path', {
                d: 'M16.963 52h-3.75c-2.585 0-4.688-2.12-4.688-4.727V30.255c0-6.257 5.047-11.346 11.25-11.346h6.446V20.8h-6.446c-5.169 0-9.375 4.241-9.375 9.455v17.018c0 1.564 1.262 2.836 2.813 2.836h1.875v-10.4h12.187V41.6H16.963V52z',
                fill: '#3F5060',
                mask: 'url(#b)'
            }),
            _react2.default.createElement('path', {
                fill: '#3F5060',
                mask: 'url(#b)',
                d: 'M13.213 41.6h2.813v-1.89h-2.813zM28.152 52H25.4c-2.584 0-4.688-2.12-4.688-4.727v-6.618h1.875v6.618c0 1.564 1.262 2.836 2.813 2.836h2.752V52z'
            }),
            _react2.default.createElement('path', {
                fill: '#A7F2EB',
                mask: 'url(#b)',
                d: 'M37.588 20.8h1.875v-1.89h-1.875z'
            }),
            _react2.default.createElement('path', {
                d: 'M46.963 17.018h-1.875c0-1.043-.841-1.89-1.875-1.89a1.885 1.885 0 0 0-1.875 1.89h-1.875c0-2.085 1.682-3.782 3.75-3.782s3.75 1.697 3.75 3.782M37.588 17.018h-1.875c0-1.043-.841-1.89-1.875-1.89a1.885 1.885 0 0 0-1.875 1.89h-1.875c0-2.085 1.682-3.782 3.75-3.782s3.75 1.697 3.75 3.782',
                fill: '#00D8C8',
                mask: 'url(#b)'
            }),
            _react2.default.createElement('path', {
                fill: '#3F5060',
                mask: 'url(#b)',
                d: 'M0 52h60v-1.89H0z'
            }),
            _react2.default.createElement('path', {
                fill: '#FFCF3F',
                mask: 'url(#b)',
                d: 'M26.25 34.036h1.875v-1.89H26.25z'
            }),
            _react2.default.createElement('path', {
                d: 'M12.074 24.582h-1.875V10.743c0-.505-.195-.98-.55-1.337l-.113-.114a3.772 3.772 0 0 1-1.099-2.674c0-1.01.39-1.96 1.1-2.674 1.414-1.43 3.884-1.43 5.302 0l.937.946A6.604 6.604 0 0 1 17.7 9.57V20.8h-1.875V9.57c0-1.263-.488-2.45-1.373-3.343l-.938-.946c-.709-.714-1.942-.714-2.651 0-.355.358-.55.832-.55 1.337s.195.98.55 1.337l.113.114a3.772 3.772 0 0 1 1.099 2.674v13.839z',
                fill: '#3F5060',
                mask: 'url(#b)'
            })
        )
    );
};

DefaultIcon.defaultProps = {
    width: '60',
    height: '52',
    viewBox: '0 0 60 52',
    xmlns: 'http://www.w3.org/2000/svg',
    xmlnsXlink: 'http://www.w3.org/1999/xlink'
};

var ProfileIcon = function (_React$Component) {
    _inherits(ProfileIcon, _React$Component);

    function ProfileIcon() {
        _classCallCheck(this, ProfileIcon);

        return _possibleConstructorReturn(this, (ProfileIcon.__proto__ || Object.getPrototypeOf(ProfileIcon)).apply(this, arguments));
    }

    _createClass(ProfileIcon, [{
        key: 'render',
        value: function render() {
            var size = this.props.size || _sizes.Sizes.md;
            size = (0, _getSize2.default)(size);
            return _react2.default.createElement(
                _layout2.default,
                this.props,
                _react2.default.createElement(DefaultIcon, { fill: this.props.hover || this.props.active ? _colors.Colors.calmWhite : _colors.Colors.claimBlack, width: size + 'px', height: size + 'px' })
            );
        }
    }]);

    return ProfileIcon;
}(_react2.default.Component);

exports.default = ProfileIcon;